// @mui
import { Box } from '@mui/material';
import IconButtonAnimate from '../../../components/animate/IconButtonAnimate';

// ----------------------------------------------------------------------

type Props = {
  onToggleCollapse: VoidFunction;
  collapseClick: boolean;
};

export default function CollapseButton({ onToggleCollapse, collapseClick }: Props) {
  return (
    <IconButtonAnimate onClick={onToggleCollapse}>
      <Box
        sx={{
          lineHeight: 0,
          transition: (theme) =>
            theme.transitions.create('transform', {
              duration: theme.transitions.duration.shorter,
            }),
          ...(collapseClick && {
            transform: 'rotate(180deg)',
          }),
        }}
      >
        {icon}
      </Box>
    </IconButtonAnimate>
  );
}

// ----------------------------------------------------------------------

const icon = (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <g fill="currentColor" fillRule="nonzero">
        <path
          d="M14.33 11.43 18.51 7.25c.41-.41.41-1.09 0-1.5-.41-.41-1.09-.41-1.5 0l-5.54 5.54c-.39.39-.39 1.02 0 1.41l5.54 5.54c.41.41 1.09.41 1.5 0 .41-.41.41-1.09 0-1.5l-4.18-4.18a.8.8 0 0 1 0-1.13Z"
          opacity=".48"
        />
        <path d="M8.33 11.43 12.51 7.25c.41-.41.41-1.09 0-1.5-.41-.41-1.09-.41-1.5 0l-5.54 5.54c-.39.39-.39 1.02 0 1.41l5.54 5.54c.41.41 1.09.41 1.5 0 .41-.41.41-1.09 0-1.5l-4.18-4.18a.8.8 0 0 1 0-1.13Z" />
      </g>
    </g>
  </svg>
);
